import { useObserver } from 'mobx-react-lite'
import React, { FC, useMemo, useContext, useEffect } from 'react'
import * as css from './styles.css'
import { StandardTableView } from '@components/UI-Components/StandardTableView/container'
import TabsStrip, { ITab } from '@components/std-components/TabsStrip'
import { VIPChannel } from '@modules/common/models/enums/VIPChannel'
import filter from 'lodash/filter'
import { isWholesaleCMOrAdmin } from '@services/commonServices'
import { productOrderTableDefService } from '../services/ProductOrderTableDefinitionService'
import { CancelProductContext } from '../context/cancelProduct-context'

const HEADERHEIGHT = 32
const ROWHEIGHT = 31

export interface OrderTableProps {
  selectedRows: any
  selectedData: any
  setSelectedData?: any
  processedOrderData: any
  disabledOrders: any
  hasRetailChannel: boolean
  hasWholesaleChannel: boolean
  setFilterData?: any
  isSelectedChannelBSGClosed?: boolean
}

export const ProductOrderTable: FC<OrderTableProps> = ({
  selectedRows,
  selectedData,
  setSelectedData,
  processedOrderData,
  disabledOrders,
  hasRetailChannel,
  hasWholesaleChannel,
  setFilterData,
  isSelectedChannelBSGClosed
}) =>
  useObserver(function useHook() {
    const {
      uiStore: {
        tabs,
        selectedChannel,
        setSelectedChannel,
        wholesaleOrders,
        retailOrders
      }
    } = useContext(CancelProductContext)

    const filteredTabs = useMemo(() => {
      return tabs.filter(tab => {
        if (tab.id === VIPChannel.Retail) {
          return hasRetailChannel && retailOrders?.length && tab
        } else if (tab.id === VIPChannel.Wholesale) {
          return hasWholesaleChannel && wholesaleOrders?.length && tab
        } else {
          return tab
        }
      })
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tabs])

    useEffect(() => {
      if (filteredTabs?.length && !selectedChannel) {
        setSelectedChannel(filteredTabs[0].id)
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filteredTabs])

    const isGMOrAdmin = !!isWholesaleCMOrAdmin()
    const isRTLOrderView = selectedChannel === VIPChannel.Retail
    const columnDef = productOrderTableDefService.buildTableViewDefinitionForProductOrder(
      isGMOrAdmin,
      isRTLOrderView
    )
    const processedOrdersByChannel = filter(processedOrderData || [], {
      internalClient: isRTLOrderView
    })

    const selectedRowsByTab = filter(selectedData || [], {
      internalClient: isRTLOrderView
    })

    return (
      <div className={css.ordersWrapper}>
        <TabsStrip
          tabHeaders={filteredTabs as ITab[]}
          onChange={({ tab }) => {
            setSelectedChannel(tab.id)
          }}
          selectedTab={decodeURIComponent(selectedChannel)}
        />
        {/* Order Table */}
        <StandardTableView
          setFilterData={setFilterData}
          hideLetterNavigation={true}
          colDef={columnDef}
          overScanCount={15}
          data={processedOrdersByChannel}
          showBodyRowBorder={true}
          headerHeight={HEADERHEIGHT}
          rowHeight={ROWHEIGHT}
          allowMultiSelect={true}
          maxSelectionLimit={processedOrderData.length}
          setSelectedData={setSelectedData}
          canSelectAll={true}
          showCountDetails={true}
          showCountDetailOnly={true}
          disabledRows={disabledOrders}
          selectedRowsByTab={selectedRowsByTab}
          selectedRows={selectedRows}
          allowDisabledRowsSelection={false}
          isTableDisabled={isSelectedChannelBSGClosed}
        />
      </div>
    )
  })
